import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { TeamsMeetingDelegationPermissionsLoadAction } from '../../domains/teamsMeetingDelegationPermissions/actions.types';

import type { TeamsMeetingDelegationPermissions } from './types';

const initialState: TeamsMeetingDelegationPermissions = {};

const teamsMeetingDelegationPermissionsReducer: Reducer<
  TeamsMeetingDelegationPermissions,
  TeamsMeetingDelegationPermissionsLoadAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'TEAMS_MEETING_DELEGATION_PERMISSIONS.LOAD_PENDING': {
      const { meetingId } = action.payload;

      return {
        ...state,
        [meetingId]: setPending(),
      };
    }

    case 'TEAMS_MEETING_DELEGATION_PERMISSIONS.LOAD_FULFILLED': {
      const { meetingId, entities } = action.payload;

      return {
        ...state,
        [meetingId]: setFulfilled(entities),
      };
    }

    case 'TEAMS_MEETING_DELEGATION_PERMISSIONS.LOAD_REJECTED': {
      const { meetingId, error } = action.payload;

      return {
        ...state,
        [meetingId]: setRejected(error),
      };
    }

    default:
      return state;
  }
};

export default teamsMeetingDelegationPermissionsReducer;
